import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';

class ScrollWrapper extends Component {
  render() {
    const { height, onScrollBottom } = this.props

    return (
      <Scrollbars
        style={{ height: height }}
        autoHide={true}
        ref="scrollbars"
        onScroll={
          () => {
            const { scrollbars } = this.refs
            const scrollSize = scrollbars.getScrollHeight()
            const scrollProggress = scrollbars.getScrollTop() + height

            if (scrollSize - scrollProggress < 1 && !!onScrollBottom) {
              onScrollBottom()
            }
          }
        }
      >
        {this.props.children}
      </Scrollbars>
    )
  }
}

export default ScrollWrapper